import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouteReuseStrategy } from '@angular/router';
import { CoreModule } from '@core/core.module';
import { CacheRouteReuseStrategy } from '@core/services/cache-route-reuse-strategy/cache-route-reuse-strategy';
import { TrackingInterceptor } from '@core/services/tracking-interceptor/tracking-interceptor.service';
import { TemplateModule } from '@project/shared/template/template.module';
import { StoreModule } from '@store/store.module';
import {
  provideCacheableAnimationLoader,
  provideLottieOptions
} from 'ngx-lottie';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthInterceptor } from './auth-interceptor';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    StoreModule,
    AppRoutingModule,
    CoreModule,
    TemplateModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    {
      provide: Window,
      useValue: window
    },
    {
      provide: RouteReuseStrategy,
      useClass: CacheRouteReuseStrategy
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TrackingInterceptor,
      multi: true
    },
    provideLottieOptions({
      player: () => import('lottie-web/build/player/lottie_light')
    }),
    provideCacheableAnimationLoader()
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
